package one.healthium.profile.navigation.settingMenu

import com.arkivanov.decompose.ComponentContext
import one.healthium.settings.ui.menu.SettingsMenuComponent

class DefaultSettingsMenuComponent(
    componentContext: ComponentContext,
    override val menuId: String,
    override val title: String,
    private val onBackClicked: () -> Unit,
) : SettingsMenuComponent, ComponentContext by componentContext {
    override fun onBackClicked() {
        onBackClicked.invoke()
    }
}